import { useQuery } from '@apollo/client';
import { MY_SOCIAL_LINKING_PLATFORMS } from '@/queries/queries';
import {
  DEFAULT_SOCIAL_LINKING_PLATFORMS,
  isSocialLinkingPlatform,
  type SocialLinkingPlatform,
} from '@/lib/account-settings/visibleSocialLinkingPlatforms';

/** Platforms the viewer may link. Facebook appears only when the backend lists it;
 * while loading or on error the defaults (without Facebook) are returned. */
export function useSocialLinkingPlatforms(): SocialLinkingPlatform[] {
  const { data, error } = useQuery<{ mySocialLinkingPlatforms: string[] }>(
    MY_SOCIAL_LINKING_PLATFORMS,
  );
  const listed = data?.mySocialLinkingPlatforms;
  if (error || !Array.isArray(listed)) return DEFAULT_SOCIAL_LINKING_PLATFORMS;
  return listed.filter(isSocialLinkingPlatform);
}
